import React from 'react'
import styled from 'styled-components'
import { animated } from 'react-spring'

export const Filters = (props) => (
  <StyledFilters {...props}>{props.children}</StyledFilters>
)

const StyledFilters = styled(animated.div)`
  overflow: visible;
  background: #fff;
  border-left: 1px solid #ddd;
  height: auto;
  position: fixed;
  z-index: 5;
  right: 0;
  top: 0;
  height: 100vh;
`

export default Filters
